import React, { memo } from 'react';
import { View } from 'react-native';
import { isMobile } from 'react-device-detect';

import { createUseStyle } from '@redlink/assets/styles';
import { useLocale } from '@redlink/assets/locale';

import { Text, IconAdd, Space } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';

export const ItemsContainer = memo(
  ({ title, description, onPress, children, style, noAction }) => {
    const { styles, colors } = useStyle();
    const { dictionary } = useLocale();
    return (
      <View style={styles.container}>
        <View style={styles.topSection}>
          <View style={styles.titlesContainer}>
            <Text style={styles.title}>{title}</Text>
            {!isMobile && <Text style={styles.description}>{description}</Text>}
          </View>
          {!noAction && (
            <Button
              {...{ onPress }}
              variant="primary"
              icon={<IconAdd color={colors.white} />}
              title={dictionary.edit}
              style={styles.button}
            />
          )}
        </View>
        <Space />
        <View style={[styles.contentContainer, style]}>{children}</View>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow }) => ({
  container: {
    ...shadow.card,
    borderRadius: 10,
    justifyContent: 'center',
    backgroundColor: colors.white,
    paddingVertical: 16,
  },
  contentContainer: {
    paddingHorizontal: 16,
  },
  topSection: {
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 16,
  },
  titlesContainer: {
    flex: 1,
  },
  button: {
    width: 104,
    height: 32,
    borderRadius: 5,
    borderColor: colors.blue1,
    backgroundColor: colors.blue1,
  },
  title: {
    fontSize: 16,
    lineHeight: 28,
    fontWeight: '500',
    color: colors.black
  },
  description: {
    fontSize: 12,
    lineHeight: 24,
    color: colors.gray21,
  },
}));
